var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ml",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M425.8 0H640v480H425.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009a00",
    d: "M0 0h212.9v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M212.9 0h214v480h-214z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMl);
export default __webpack_public_path__ + "static/media/ml.fa530666ce9e170dc6cdcc03b6ef2f68.svg";
export { ForwardRef as ReactComponent };